export default "__VITE_ASSET__z_eO8osX__"